import React, { FC } from 'react';
import FormField from './Form.field';

const isLocked = (field) => {
  return (typeof field !== 'undefined' || field != null) ? field.locked : true;
};

const getWidths = (section) => {
  const columns = section.fieldSets.map(fieldSet => ({ width: fieldSet.width }));
  const sum = columns.reduce((acc, col) => acc + col.width, 0);
  return columns.map(col => Math.round((col.width / sum) * 16));
};

const Form: FC<any> = ({ renderData, data, params, editData, setFormEditData, viewType }) => {
  if (!renderData) return null;

  return (
    <div className="flex flex-col pt-3 pb-3 pl-7 pr-1">
      {renderData.sections.map((section, i) => {
        const widths = getWidths(section);
        return (
          <div key={`RowOuter-${i}`} className="flex flex-wrap w-full">
            {section.fieldSets.map((set, j) => (
              <div key={`Column-${j}`} className="box-border pr-6" style={{ width: `${(widths[j] / 16) * 100}%` }}>
                {set.fields.length === 0 ? (
                  set.sections.map((subSection, k) => {
                    const subWidths = getWidths(subSection);
                    return (
                      <div key={`SubRow-${k}`} className="flex flex-wrap w-full">
                        {subSection.fieldSets.map((subSet, l) => (
                          <div key={`SubColumn-${l}`} className="box-border pr-6" style={{ width: `${(subWidths[l] / 16) * 100}%` }}>
                            {subSet.fields.map((field, m) => (
                              <div key={`SubField-${m}`} className={`float-left w-full ${field.type !== 'string' ? 'w-1/2' : ''} mb-0`}>
                                <FormField
                                  field={field}
                                  fieldLocked={isLocked(field)}
                                  key={`FormField-${field._key}`}
                                  data={data}
                                  params={params}
                                  editData={editData}
                                  setFormEditData={setFormEditData}
                                  viewType={viewType}
                                  renderData={renderData}
                                />
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    );
                  })
                ) : (
                  set.fields.map((field, n) => (
                    <div key={`Field-${n}`} className="mb-0">
                      <FormField
                        field={field}
                        fieldLocked={isLocked(field)}
                        key={`FormField-${field._key}`}
                        data={data}
                        params={params}
                        editData={editData}
                        setFormEditData={setFormEditData}
                        viewType={viewType}
                        renderData={renderData}
                      />
                    </div>
                  ))
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default Form;
